<template>
    <div class="home dashboard-home">
        <!-- 顶部条：返回 + 标题 + 退出 -->
        <!-- 顶部条：返回 + 标题 + 退出 -->
        <div class="top-bar">
            <div class="top-left" @click="goBack">
                <van-icon name="arrow-left" size="18" color="#4b5563" />
                <span class="top-back-text">返回</span>
            </div>
            <div class="top-center">
                <div class="top-title">{{ username || '学生' }} · 课程列表</div>
            </div>
            <div class="top-right" @click="onLogout">
                <span class="top-exit-text">退出</span>
            </div>
        </div>


        <div class="dash-container">
            <!-- 课程列表 -->
            <van-list v-model="loading" :finished="finished" finished-text="仅展示最近 100 条数据" @load="onLoad">
                <div class="course-list">
                    <!-- 空状态 -->
                    <div v-if="list.length === 0 && !loading" class="empty-state">
                        <van-empty description="暂时还没有上课记录" />
                    </div>

                    <!-- 课程项 -->
                    <div v-for="(item, idx) in list" :key="idx" class="course-item" @click="navigateToLesson(item)">
                        <!-- 时间 + 评分 -->
                        <div class="course-header">
                            <div class="course-time">
                                <van-icon name="clock-o" size="14" color="#2563eb" />
                                <span class="course-time-text">{{ item.lesson_time }}</span>
                            </div>

                            <div class="course-rating">
                                <van-rate v-if="item.rate" v-model="item.rate" :size="18" color="#2563eb"
                                    void-color="#e5edff" readonly />
                                <span v-else class="no-rating">等待评分</span>
                            </div>
                        </div>

                        <!-- 反馈预览：直接展示内容 -->
                        <div v-if="item.feedback" class="course-feedback" v-html="item.feedback"></div>

                        <div v-else class="course-feedback empty-feedback">
                            <van-icon name="comment-o" size="14" color="#9ca3af" />
                            <span class="empty-feedback-text">老师正在填写反馈</span>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    name: "MainView",
    data() {
        return {
            loading: false,
            finished: false,
            page: 1,
            list: []
        };
    },
    computed: {
        ...mapGetters(["userId", "username", "token"])
    },
    mounted() {
        this.onLoad();
    },
    methods: {
        onLoad() {
            this.loading = true;

            if (this.finished === true || this.page > 20) {
                this.loading = false;
                return;
            }

            axios
                .get(`/api/student/index?page=${this.page}`, {
                    headers: {
                        'Authorization': `Bearer ${this.token}`
                    }
                })
                .then(response => {
                    if (response.data && Array.isArray(response.data.data.list)) {
                        if (response.data.data.list.length < 10) {
                            this.finished = true;
                        }

                        this.list = this.list.concat(response.data.data.list);
                        this.page++;
                    } else {
                        alert("获取课程数据失败，请稍后重试");
                    }

                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;

                    // 令牌过期 / 老版本令牌失效 → 清掉本地登录态，回登录页。
                    // 不说"网络错误"，否则学生会一直去查网络。
                    if (error.response && error.response.status === 401) {
                        this.$store.dispatch("setUserId", "");
                        this.$store.dispatch("setUsername", "");
                        this.$store.dispatch("setToken", "");
                        this.$toast.fail("登录已失效，请重新登录");
                        this.$router.push("/login");

                        return;
                    }

                    this.$toast.fail("网络错误，请检查您的连接");
                });
        },

        onLogout() {
            this.$store.dispatch("setUserId", "");
            this.$store.dispatch("setUsername", "");
            this.$store.dispatch("setToken", "");
            this.$router.push("/login");
        },

        goBack() {
            this.$router.back();
        },

        navigateToLesson(item) {
            if (!item.id) {
                this.$toast.fail("课程 ID 未定义，请稍后重试");
                return;
            }

            if (!item.feedback) {
                this.$toast.fail("课程暂时未有反馈，请稍后查看");
                return;
            }

            this.$router.push(`/lesson/${item.id}`);
        }
    }
};
</script>

<style scoped>
/* 整体背景，与登录 / 详情统一 */
.dashboard-home {
    min-height: 100vh;
    background:
        radial-gradient(circle at 0 0, #e6edff 0, transparent 45%),
        radial-gradient(circle at 100% 0, #fef3c7 0, transparent 45%),
        linear-gradient(to bottom, #f4f5fb 0, #f9fafb 100%);
    box-sizing: border-box;
}

/* 顶部条：替代传统 NavBar */
.top-bar {
    position: sticky;
    top: 0;
    z-index: 10;
    padding: 10px 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(to bottom,
            rgba(244, 245, 251, 0.96),
            rgba(244, 245, 251, 0.92),
            transparent);
    backdrop-filter: blur(12px);
    box-sizing: border-box;
}

.top-left {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.top-back-text {
    margin-left: 4px;
    font-size: 13px;
    color: #4b5563;
}

.top-center {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.top-title {
    font-size: 16px;
    font-weight: 600;
    color: #111827;
}

.top-sub {
    margin-top: 2px;
    font-size: 12px;
    color: #6b7280;
}

.top-right {
    display: flex;
    align-items: center;
    cursor: pointer;
}

/* 极简文字按钮 */
.top-exit-text {
    font-size: 13px;
    color: #6b7280;
}

/* 可选：点击时稍微深一点 */
.top-right:active .top-exit-text {
    color: #374151;
}



/* 内层容器 */
.dash-container {
    padding: 4px 16px 20px;
    box-sizing: border-box;
}

/* 课程列表容器 */
.course-list {
    padding-top: 8px;
    display: flex;
    flex-direction: column;
    gap: 12px;
    box-sizing: border-box;
}

/* 课程卡片 */
.course-item {
    background: #ffffff;
    border-radius: 16px;
    padding: 12px 14px;
    box-shadow:
        0 12px 26px rgba(148, 163, 184, 0.26),
        0 0 0 1px rgba(226, 232, 240, 0.9);
    box-sizing: border-box;
}

/* 课程头部：时间 + 评分 */
.course-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}

.course-time {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #374151;
}

.course-time-text {
    margin-left: 4px;
}

/* 评分 */
.course-rating {
    display: flex;
    align-items: center;
}

.no-rating {
    font-size: 13px;
    color: #9ca3af;
}

/* 反馈预览：字体略大一点 */
.course-feedback {
    font-size: 14px;
    color: #4b5563;
    line-height: 1.8;
    padding-top: 6px;
    border-top: 1px solid #eef0f4;
    text-align: left;
}

/* 空反馈 */
.empty-feedback {
    display: flex;
    align-items: center;
    color: #9ca3af;
    padding-top: 6px;
    border-top: 1px solid #eef0f4;
}

.empty-feedback-text {
    margin-left: 4px;
    font-size: 13px;
}

/* 空状态 */
.empty-state {
    padding-top: 40px;
}

/* 加载完成提示 */
.van-list__finished-text {
    color: #6b7280;
    padding: 15px 0;
    font-size: 13px;
}

/* 小屏适配 */
@media (max-width: 375px) {
    .top-bar {
        padding: 8px 10px;
    }

    .dash-container {
        padding: 4px 12px 18px;
    }

    .course-item {
        padding: 10px 12px;
    }
}
</style>
